/**
 * Icon Helper Utilities
 * Utilities for rendering icons in the chat interface
 */

import React from 'react';

export function getIconForChip(iconName?: string): React.ReactNode {
  if (iconName === 'sun') {
    return (
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M8 11.3333C9.84095 11.3333 11.3333 9.84095 11.3333 8C11.3333 6.15905 9.84095 4.66667 8 4.66667C6.15905 4.66667 4.66667 6.15905 4.66667 8C4.66667 9.84095 6.15905 11.3333 8 11.3333Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8 1.33333V2.66667M8 13.3333V14.6667M2.66667 8H1.33333M14.6667 8H13.3333M3.28595 3.28595L4.22928 4.22928M11.7707 11.7707L12.714 12.714M3.28595 12.714L4.22928 11.7707M11.7707 4.22928L12.714 3.28595'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    );
  }
  if (iconName === 'directions') {
    return (
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M8 1.33333V14.6667M8 14.6667L3.33333 10M8 14.6667L12.6667 10'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M3.33333 6L8 1.33333L12.6667 6'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    );
  }
  return null;
}
